module.exports = __webpack_public_path__ + "static/media/icon_calendar_light.bd50a589.svg";